/**
 * Author：brand
 * Creation Time：2019-06-17 13:38
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

/**
 *
 * @param params
 * @returns {*}
 */
export function getWxAppListAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/authorizedWxappList',
    method: 'POST',
    params
  })
}
export function setWxAppShopConfigAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/wxappShopSet',
    method: 'POST',
    params
  })
}
export function unbindWechatAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/unauthorizedGZH',
    method: 'POST',
    params
  })
}
export function initBindUrlAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/getWxappBindcomponentURL',
    method: 'POST',
    params
  })
}
export function initGzhBindUrlAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/getBindcomponentURL',
    method: 'POST',
    params
  })
}
export function getGzhRedirectUrlAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/redirectUrl',
    method: 'POST',
    params
  })
}
export function getGzhListAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/authorizedGZHList',
    method: 'POST',
    params
  })
}

export function getReplyAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/getsubscribe',
    method: 'POST',
    params
  })
}

export function editReplyAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/updatesubscribe',
    method: 'POST',
    params
  })
}

export function delReplyAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/deletesubscribe',
    method: 'POST',
    params
  })
}

export function getGzhRulesAPI (params) {
  return ax({
    url: '/wlapi/autoreply/getRules',
    method: 'POST',
    params
  })
}
export function editGzhRulesAPI (params) {
  return ax({
    url: '/wlapi/autoreply/updateRule',
    method: 'POST',
    data:params
  })
}
export function delGzhRulesAPI (params) {
  return ax({
    url: '/wlapi/autoreply/deleteRule',
    method: 'POST',
    params
  })
}
export function delGzhKeywordsAPI (params) {
  return ax({
    url: '/wlapi/autoreply/delKeyword',
    method: 'POST',
    params
  })
}

/**
 * 公众号菜单
 * @param params
 */
export function getMenusAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/getmenu',
    method: 'POST',
    params
  })
}
export function saveMenusAPI (params) {
  return ax({
    url: '/wlapi/wxgzh/savemenu',
    method: 'POST',
    data:params
  })
}

/**
 * 网站接入
 * @param params
 * @returns {*}
 */
export function joinGetQQAndQRCodeConfigAPI (params) {
  return ax({
    url: '/wlapi/widget/isSetAuth',
    method: 'POST',
    data:params
  })
}


export function joinUploadQRcodeAPI (params) {
  return ax({
    url: '/wlapi/widget/setWxQRCode',
    method: 'POST',
    data:params
  })
}
export function joinDelQRcodeAPI (params) {
  return ax({
    url: '/wlapi/widget/delWxQRCode',
    method: 'POST',
    data:params
  })
}

export function joinGetQRcodeAndQQAPI (params) {
  return ax({
    url: '/wlapi/automsgsetting/getAutoSet',
    method: 'POST',
    data:params
  })
}

export function joinGetAPPConfigAPI (params) {
  return ax({
    url: '/wlapi/setting/getAppserct',
    method: 'POST',
    data:params
  })
}
export function joinGetWXConfigListAPI (params) {
  return ax({
    url: '/wlapi/wxCheck/getCheckList',
    method: 'GET',
    data:params
  })
}

export function joinUploadWXConfigFileAPI (params) {
  return ax({
    url: '/wlapi/wxCheck/upload',
    method: 'POST',
    data:params
  })
}

export function joinDelWXConfigFileAPI (params) {
  return ax({
    url: '/wlapi/wxCheck/deletes',
    method: 'POST',
    data:params
  })
}

/**
 * 绑定微博(绑定)
 * @param params
 */
export function joinAddWEIBOAPI (params) {
  return ax({
    url: '/wlapi/weibo/addWeiboBind',
    method: 'POST',
    params
  })
}
/**
 * 绑定微博(获取绑定列表)
 * @param params
 */
export function joinGetWEIBOListAPI (params) {
  return ax({
    url: '/wlapi/weibo/weiboBindList',
    method: 'POST',
    data:params
  })
}
/**
 * 绑定微博(解除绑定)
 * @param params
 */
export function joinDelWEIBOConfigAPI (params) {
  return ax({
    url: '/wlapi/weibo/delWeiboBind',
    method: 'POST',
    params
  })
}
/**
 * 绑定微博(获取微博配置信息 )
 * @param params
 */
export function joinGetWEIBOConfigAPI (params) {
  return ax({
    url: '/wlapi/weibo/getWeiboInfo',
    method: 'POST',
    data:params
  })
}


// 获取聊天按钮样式
export function joinGetBtnConfigAPI (params) {
  return ax({
    url: '/wlapi/setting/getConfigValue',
    method: 'POST',
    data:params
  })
}
// 保存聊天按钮样式
export function joinSaveBtnConfigAPI (params) {
  return ax({
    url: '/wlapi/embedpluginssetting/editChatStylePC',
    method: 'POST',
    data:params
  })
}

// 保存聊天按钮样式
export function joinSaveBtnConfigMobAPI (params) {
  return ax({
    url: '/wlapi/embedpluginssetting/editChatStyleMob',
    method: 'POST',
    data:params
  })
}
// xiugai
export function changeChatQRCOdeAPI (params) {
  return ax({
    url: '/wlapi/public/createQrcodeUrl',
    method: 'POST',
    responseType: 'blob',
    params
  })
}
// 获取图标配置列表
export function getIconMenuListAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/iconMenuList',
    method: 'POST',
    params
  })
}

// 添加图标配置
export function addIconMenuAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/addIconMenu',
    method: 'POST',
    params
  })
}

// 删除图标配置
export function delIconMenuAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/delIconMenu',
    method: 'POST',
    params
  })
}
// 编辑图标配置
export function editIconMenuAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/editIconMenu',
    method: 'POST',
    params
  })
}
// 访客来源标识列表
export function getVisitorSourceQkAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/visitorSourceQk',
    method: 'POST',
    params
  })
}


/**
 *  author : wuzhiying
  * createTime:2020.04.07 17:39
 */ 
// 给公众号绑定客服
export function gzhBindCs (params) {
  return ax({
    url: '/wlapi/assignCs/saveAssignCs',
    method: 'POST',
    data:params
  })
}